import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'

import LevelWrapup from 'src/pages/LevelWrapup/LevelWrapup'
import LevelWrapupPlaceholder from 'src/pages/LevelWrapup/LevelWrapupPlaceholder'
import DataFetchError, {
  ERROR_CODE_500,
} from 'src/ui/DataFetchError/DataFetchError'

const GET_LEVEL_WRAPUP = gql`
  query GET_LEVEL_WRAPUP($l2Code: LanguageEnum!, $cefrLevel: CefrLevelCode!) {
    currentUser {
      name
      certification: lastCompletedCertification(
        code: $l2Code
        kinds: [major, partial_major]
        cefrLevel: $cefrLevel
      ) {
        kind
        completedAt
        startedAt
        selfStudyInMinutes
        liveLessonsInMinutes
        licenseNumber
        linkUrl
      }
    }
  }
`

const LevelWrapupLazy = ({ l2Code, cefrLevel }) => {
  const response = useQuery(GET_LEVEL_WRAPUP, {
    variables: {
      l2Code,
      cefrLevel,
    },
    fetchPolicy: 'network-only',
  })
  const certification = response.data?.currentUser?.certification
  const fullName = response.data?.currentUser?.name

  if (response.loading) {
    return <LevelWrapupPlaceholder />
  }

  if (certification) {
    return (
      <LevelWrapup
        l2Code={l2Code}
        cefrLevel={cefrLevel}
        fullName={fullName}
        certification={certification}
      />
    )
  }

  return <DataFetchError errorCode={ERROR_CODE_500} />
}

LevelWrapupLazy.propTypes = {
  l2Code: PropTypes.string.isRequired,
  cefrLevel: PropTypes.string.isRequired,
}

export default LevelWrapupLazy
